import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {ResizeEvent} from "angular-resizable-element";
import { ApplicantFormControllerService } from "../../../../../services/form-controller/applicant-form-controller.service";
import { FormioControllerService } from "../../../../../services/form-controller/formio-controller.service";
import FormUtils from "../../../../utils/form-utils.component";
import {Store} from "../../../../../services/store.service";
import {BaseError} from "../../../base-error";
import { environment } from "../../../../../../environments/environment";
import {ToastrService} from "ngx-toastr";
import {BaseForm} from "../../../../../models/base-form";
import Helpers from "../../../../../utils/helpers";
import {FormControllerService} from "../../../../../services/form-controller/form-controller.service";

@Component({
  selector: "applicant-form",
  templateUrl: "./applicant-form.component.html",
  providers: [ApplicantFormControllerService, FormioControllerService],
})

export class ApplicantFormComponent extends BaseError implements OnInit {

  public serviceId: string;
  @Input() public applicantForm: BaseForm = new BaseForm();
  @Input() public focusCompKey?: string;
  @Input() public determinantMapById: { [key: string]: string };
  @Output() public formReverted: EventEmitter<BaseForm> = new EventEmitter();
  public showFieldsGenerator: boolean = false;
  public style: object = {};
  public activeTab: string = "form";
  public showHistory: boolean = false;


  constructor(private route: ActivatedRoute,
              public store: Store,
              public toastr: ToastrService,
              private formControllerService: FormControllerService,
              public applicantFormController: ApplicantFormControllerService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.store.state.common.applicantFormPage.set("applicant-form");
      // this.loadForm();
    });
  }

  public openHistory() {
    this.showHistory = true;
  }

  public closeHistory() {
    this.showHistory = false;
  }

  public changeForm(revisionNumber: string): void {
    if (revisionNumber) {
      // Step 1: GET the schema for validation
      this.applicantFormController.getFormSchemaForRevision(this.serviceId, revisionNumber).subscribe((schema) => {
        if (schema) {
          // Step 2: Validate schema for duplicate keys
          const result = Helpers.validateFormSchema(schema);
          if (Array.isArray(result) && result.length > 0) {
            this.error("Please reload page!\n" + Helpers.generateValidationErrorMessages(result).join("\n"), 'Validation error');
          }
          else {
            // Step 3: If valid, call PUT to revert (triggers cleanup of orphaned relations)
            this.applicantFormController.revertFormToRevision(this.serviceId, revisionNumber).subscribe(
              () => {
                // Step 4: Reload the form after successful reversion
                this.applicantFormController.getApplicantForm(this.serviceId, false).subscribe(
                  (data) => {
                    this.applicantForm = data ? data : this.applicantForm;
                    this.formReverted.emit(this.applicantForm);
                    this.responseSuccessful("Form reverted successfully");
                  },
                  (error) => this.showErrorMessage(error)
                );
              },
              (error) => this.showErrorMessage(error)
            );
          }
        }
      });
    }
  }

  public saveTutorial(e) {
    if (e) {
      this.applicantForm.tutorials.general = e;
      this.saveForm(this.applicantForm.formSchema);
    }
  }

  public notifyTabChange(newtab: string): void {
    this.activeTab = newtab;
  }

  public saveForm(formSchema: any) {

    if (this.applicantForm.id) {
      // add version to distinguish old and new form builder components
      if (formSchema && formSchema.components) {
        for (const comp of formSchema.components) {
          FormUtils.updateWithVersion(comp);
          FormUtils.updateTableAttributes(comp);
          FormUtils.completeColumnsRows(comp);
        }
      }
    }

    this.applicantForm.formSchema = formSchema;
    if (this.applicantForm.id) {
        this.applicantFormController.saveApplicantForm(this.applicantForm).subscribe(
            () => undefined,
            (error) => this.showErrorMessage(error),
        );
    } else {
      this.applicantFormController.createApplicantForm(this.serviceId, this.applicantForm).subscribe(
        (data) => {
          this.applicantForm = (data ? data : this.applicantForm);
        },
      );
    }
  }

  public activateForm() {
    this.applicantFormController.activateApplicantForm(this.applicantForm.id, this.applicantForm.active).subscribe();
  }

  public importOldApplicantForm() {
    this.applicantFormController.importOldApplicantForm(this.serviceId).subscribe(
      (data) => this.applicantForm = (data ? data : this.applicantForm),
    );
  }

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }

  public downloadSchema() {
    this.formControllerService.downloadSchemaWithRelations(this.applicantForm.id).subscribe(
      (data) => {
        const blob = new Blob([data], { type: "application/octet-stream" });
        const downloadURL = window.URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = downloadURL;
        link.download = `${this.store.state.common.serviceName}_applicant_form_schema.json`;
        link.click();
      },
      (error) => this.showErrorMessage(error),
    );
  }
}
